import { useQuery } from '@apollo/client/react';
import { i18n } from '@lingui/core';
import { t } from '@lingui/core/macro';
import { Box, Chip, Loader, Typography } from '@pocketlaw/tetris';
import { Falcon } from '@pocketlaw/tetris/macro';
import { dashboardTemplates, useInsightsTemplates } from './Context';
import { TemplatePreviewDocument } from './TemplatePreview.gql';
import { Visualization } from '../Visualization';
import { WidgetBody, WidgetContainer, WidgetHeader } from '../Widget/styled';
import { WidgetGridLayout } from '../WidgetGrid/WidgetGridLayout';
export function TemplatePreview() {
    const { selected } = useInsightsTemplates();
    const template = dashboardTemplates.find((mock) => mock.id === selected);
    const { slots } = template || {};
    // Prime cache with data for metadata properties
    const { loading } = useQuery(TemplatePreviewDocument);
    if (!slots) {
        return null;
    }
    if (loading) {
        return (<Box width="100%" height="100%" alignItems="center" justifyContent="center">
        <Loader />
      </Box>);
    }
    const layouts = {
        lg: slots.map((slot) => ({
            i: slot.id,
            x: slot.x,
            y: slot.y,
            w: slot.w,
            h: slot.h,
            widgetId: slot.widgetId,
            static: true,
        })),
    };
    return (<WidgetGridLayout layouts={layouts}>
      {slots.map((slot) => (<WidgetContainer $editMode={false} key={slot.id}>
          <WidgetHeader width="100%" p="2xl" pb="0" alignItems="center" gap="md">
            <Typography $fontWeight="bold" $fontSize="large" $appearance="300" $lineHeight="neutralized" $truncate>
              {i18n._(slot.widget.label)}
            </Typography>
            <Box ml="auto" alignItems="center" gap="md">
              {slot.widget.filters && (<Chip label={t({
                    message: 'Filtered',
                    comment: 'Indicator on widget if data is filtered',
                    context: 'insights',
                })} icon={<Falcon icon="bars-filter"/>}/>)}
            </Box>
          </WidgetHeader>

          <WidgetBody alignItems="center" justifyContent="center" p="2xl" pt="0">
            <Visualization type={slot.widget.type} aggregations={slot.widget.aggregations} filters={slot.widget.filters} colorScheme={slot.widget.colorScheme} isHorizontal={slot.widget.isHorizontal}/>
          </WidgetBody>
        </WidgetContainer>))}
    </WidgetGridLayout>);
}
